<template>
<section>
    <h1 class="main-title grid-container layer1">About</h1>
    <div class="mobile-navigation about layer3"></div>

    <Carousel classes="on-home" :items="result" v-if="result"></Carousel>

    <h1 class="main-title grid-container layer1">Off Stage</h1>
    <div class="mobile-navigation off-stage layer2"></div>

    <div class="offstage-list-homepage layer1">
        <div class="grid-container grid-100">
            <div class="grid-50 push-50 grid-parent">
                <div class="video-item grid-100 grid-parent">
                    <div class="video-header grid-100 grid-parent">
                        <div class="video">
                            <iframe src="https://player.vimeo.com/video/233687092" width="640" height="352"
                                    frameborder="0" webkitallowfullscreen mozallowfullscreen
                                    allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import Carousel from '../Carousel'

export default {
    name: "About",
    components: {
        Carousel,
    },
    props: {
        result: {
            type: Array,
            required: true,
        },
    },
};
</script>


// WEBPACK FOOTER //
// About.vue?4007c794